import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=1fc79378&scoped=true"
import script from "./side-nav.vue?vue&type=script&lang=js"
export * from "./side-nav.vue?vue&type=script&lang=js"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=1fc79378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc79378",
  null
  
)

export default component.exports